import Vue from 'vue'
import appLoader from '@/helpers/AppLoader.js'
import * as query from '@/helpers/query'
import * as moment from 'moment'
import * as Network from '@/helpers/network'
import * as Notif from '@/helpers/notif.js'
import * as Utils from '@/helpers/utils.js'
import Errors from 'shared/helpers/errors'
import * as api from '@/helpers/api'
import * as apiService from '@/helpers/apiService'
import axios from 'axios'
import novaApi from '@/network/novaApi.js'
import * as Analytics from '@/helpers/analytics.js'
import Language from '@/helpers/Language'
import * as env from '@/helpers/env'
import t from '@/helpers/currencyTranslator'

export default vue => {
    Vue.prototype.$api = api
    Vue.prototype.$moment = moment
    Vue.prototype.$Network = Network
    Vue.prototype.$Utils = Utils
    Vue.prototype.$Errors = Errors
    Vue.prototype.$axios = axios
    Vue.prototype.$apiService = apiService
    Vue.prototype.$novaApi = novaApi

    Vue.prototype.$Notif = Notif
    Vue.prototype.$query = query
    Vue.prototype.$t = t
    Vue.prototype.$env = env
    Vue.prototype.$Analytics = Analytics
    Vue.prototype.$appLoader = new appLoader(vue)
    Vue.prototype.$Language = new Language(vue)
}
